import { Order } from '@@types'
import { useTranslation } from 'react-i18next'

import { useModalStore } from '@features/modal'

import OrderRatingModal from '@widgets/order-rating-modal/ui/OrderRatingModal'


export interface UseOrderRatingModalProps {
  order: Order
  onSuccess?: () => void
}

export default function useOrderRatingModal (props: UseOrderRatingModalProps) {
  const { order, onSuccess } = props
  const { openModal, closeModal } = useModalStore()
  const { t: to } = useTranslation('order')

  const openOrderRatingModal = () => {
    openModal(
      'orderRating',
      <OrderRatingModal order={order} onSuccess={onSuccess} />,
      {
        title: to('feedback.title'),
        description: to('feedback.description'),
      },
    )
  }

  const closeOrderRatingModal = () => {
    closeModal('orderRating')
  }

  return {
    openOrderRatingModal,
    closeOrderRatingModal,
  }
}
